/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useEffect, useState } from "react";
import { FloatingPanelManager } from "./FloatingPanelManager";
import { offEvent, onEvent } from "@adapptio/lib-shared";
import { FloatingPanelHost } from "./FloatingPanelHost";

export interface IFloatingPanelProviderProps {
	manager: FloatingPanelManager;
}

export const FloatingPanelProvider: React.FC<IFloatingPanelProviderProps> = ({ manager }) => {
	const [ entries, setEntries ] = useState(() => manager.getEntries());

	useEffect(() => {
		const handleEntriesChange = () => setEntries(manager.getEntries());

		onEvent(manager.onEntriesChange, handleEntriesChange);

		return () => {
			offEvent(manager.onEntriesChange, handleEntriesChange);
		};
	}, []);

	return (
		<>
			{entries.map((entry) => (
				<FloatingPanelHost key={entry.id} entry={entry} />
			))}
		</>
	);
};
